"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("../styles");
const Header = ({ onClose }) => {
    const handleClick = () => onClose();
    return ((0, jsx_runtime_1.jsx)(styles_1.DialogHeader, { children: (0, jsx_runtime_1.jsx)("span", { onClick: handleClick, children: (0, jsx_runtime_1.jsx)(styles_1.CloseButton, {}) }) }));
};
exports.default = Header;
